// extracted by mini-css-extract-plugin
module.exports = {"workspace":"Workspace_workspace__1WrhF","noElement":"Workspace_noElement__2pNCQ"};